import React from 'react';
import { Form } from '@ant-design/compatible';
import { Input, Select, Modal, message } from 'antd';
import { USER_CREATE_SUCCESS, USER_CREATE_ERROR } from './../../../../actions/User';
const FormItem = Form.Item;

class CreateForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDirty: false,
    };
  }

  /**
   * Action success & errors handling
   * @param prevProps - previous props from earlier state
   */
  componentDidUpdate(prevProps) {
    this.handleActionResponseNotifications(this.props.actionResponse);
  }

  /**
   * Handles notifications for the action response
   * @param actionResponse - the response of the action made
   */
  handleActionResponseNotifications(actionResponse) {
    if (actionResponse === null) {
      return;
    }

    switch (actionResponse.get('type')) {
      case USER_CREATE_ERROR:
        message.error('Der er opstået en fejl, prøv igen.');
        break;

      case USER_CREATE_SUCCESS:
        message.success('Brugeren blev oprettet.');
        this.handleCancel();
        break;

      default:
        break;
    }
    this.props.clearActionResponse();
  }

  /**
   * Validates & submits data to backend
   * @param e is the submit button.
   */
  handleSubmit = (e) => {
    e.preventDefault();
    const { onCreate, getCompanyIdFromCompanyName } = this.props;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { username, name, company, authority } = values;
        const companyId = Number.isInteger(company)
          ? company
          : getCompanyIdFromCompanyName(company);
        const user = { username, name, companyId, authority };
        onCreate(user);
      }
    });
  };

  /**
   * Closes create window & resets all fields on cancel
   */
  handleCancel = () => {
    this.props.onCancel();
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8, textAlign: 'left' },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return (
      <Modal
        width={'50%'}
        visible={this.props.visible}
        title={'Opret ny bruger'}
        okText={'Opret'}
        cancelText={'Annuller'}
        onCancel={this.handleCancel}
        onOk={this.handleSubmit}
        confirmLoading={this.props.isLoading}
      >
        <Form>
          <FormItem {...formItemLayout} label='Navn'>
            {getFieldDecorator('name', {
              rules: [
                {
                  required: true,
                  message: 'Navn skal udfyldes.',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>
          <FormItem {...formItemLayout} label={'Email'}>
            {getFieldDecorator('username', {
              rules: [
                {
                  type: 'email',
                  message: 'Email-adressen er ikke gyldig',
                },
                {
                  required: true,
                  message: 'Email skal udfyldes.',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>
          {/*<FormItem
            {...formItemLayout}
            label={'Password'}
          >
            {getFieldDecorator('password', {
              rules: [{
                required: true, message: 'Password skal udfyldes.',
              }, {
                validator: (rule, value, callback) => this.props.validateToNextPassword(rule, value, callback, this),
              }],
            })(
              <Input type={'password'} />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label={'Bekræft Password'}
          >
            {getFieldDecorator('confirm', {
              rules: [{
                required: true, message: 'Bekræft password skal udfyldes.',
              }, {
                validator: (rule, value, callback) => this.props.compareToFirstPassword(rule, value, callback, this.props.form),
              }],
            })(
              <Input type={'password'} onBlur={(e) => this.props.handleConfirmBlur(e, this)} />
            )}
          </FormItem>*/}
          <FormItem {...formItemLayout} label={'Virksomhed'}>
            {getFieldDecorator('company', {
              initialValue:
                this.props.companies.length === 1 ? this.props.companies[0].props.children : '',
              rules: [
                {
                  required: true,
                  message: 'Virksomhed skal udfyldes',
                },
              ],
            })(
              this.props.companies.length > 1 ? (
                <Select showSearch={true} optionFilterProp={'children'}>
                  {this.props.companies}
                </Select>
              ) : (
                <Input disabled={true} />
              )
            )}
          </FormItem>
          <FormItem {...formItemLayout} label={'Rettigheder'}>
            {getFieldDecorator('authority', {
              initialValue:
                this.props.userRoles.length === 1 ? this.props.userRoles[0].props.value : '',
              rules: [
                {
                  required: true,
                  message: 'Rettigheder skal udfyldes',
                  whitespace: true,
                },
              ],
            })(
              this.props.userRoles.length > 1 ? (
                <Select>{this.props.userRoles}</Select>
              ) : (
                <Input disabled={true} />
              )
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(CreateForm);
